import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined } from "../utils";

class DIDITooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      className,
      fontFamily,
      fontSize,
      labelFill,
      longFill,
      shortFill,
      textFill,
      displayFormat,
      yAccessor,
      options,
      origin: originProp,
      displayValuesFor,
      onClick,
    } = this.props;

    const origin = functor(originProp);
    const {
      chartConfig: { width, height },
    } = moreProps;
    const [x, y] = origin(width, height);

    const currentItem = displayValuesFor(this.props, moreProps);
    let longValue = "n/a";
    let shortValue = "n/a";

    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      if (isDefined(item?.long)) {
        longValue = displayFormat(item.long);
      }
      if (isDefined(item?.short)) {
        shortValue = displayFormat(item.short);
      }
    }

    const { highPeriod, midPeriod, lowPeriod } = options || {};
    const label = `DIDI (${highPeriod ?? "?"}, ${midPeriod ?? "?"}, ${lowPeriod ?? "?"}): `;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-didi"
      >
        <ToolTipText
          fontFamily={fontFamily}
          fontSize={fontSize}
          fill={textFill}
        >
          <ToolTipTSpanLabel fill={labelFill}>{label}</ToolTipTSpanLabel>
          <ToolTipTSpanLabel fill={labelFill}>Long: </ToolTipTSpanLabel>
          <tspan fill={longFill}>{longValue}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>{"  Short: "}</ToolTipTSpanLabel>
          <tspan fill={shortFill}>{shortValue}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

DIDITooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  longFill: PropTypes.string,
  shortFill: PropTypes.string,
  displayFormat: PropTypes.func,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.shape({
    highPeriod: PropTypes.number,
    midPeriod: PropTypes.number,
    lowPeriod: PropTypes.number,
  }),
};

DIDITooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip react-stockcharts-didi-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor,
  labelFill: "#6B7280",
  textFill: "#F9FAFB",
  longFill: "#FF0000",
  shortFill: "#00FF00",
};

export default DIDITooltip;
